module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens6-507c80a67f0bd69b71dfcb3971b46a73.jpg";